import { useState, useEffect } from 'react';

export default (track) => {
  const [isSwitchedOn, setIsSwitchedOn] = useState(track ? !track.isSwitchedOff : false);

  useEffect(() => {
    setIsSwitchedOn(track ? !track.isSwitchedOff : false);

    if (track) {
      const setSwitchedOn = () => setIsSwitchedOn(true);
      const setSwitchedOff = () => setIsSwitchedOn(false);
      track.on('switchedOn', setSwitchedOn);
      track.on('switchedOff', setSwitchedOff);
      return () => {
        track.off('switchedOn', setSwitchedOn);
        track.off('switchedOff', setSwitchedOff);
      };
    }
  }, [track]);

  return isSwitchedOn;
};
